class QuantityRadioGroup extends HTMLElement {
  constructor() {
    super();

    this.radios = Array.from(
      this.querySelectorAll("[data-quantity-radio-group-input]"),
    );

    this.dependants = Array.from(
      this.querySelectorAll("[data-quantity-radio-group-follow]"),
    );
    
    this.radios.forEach((radio) => {
      radio.addEventListener("change", this.updateDependants.bind(this));
    });

    const params = new URLSearchParams(location.search);
    const quantity = params.get("quantity");

    if (quantity) {
      this.radios.forEach((radio) => {
        if (radio.value === quantity) {
          radio.checked = true;
          this.updateDependants();
        }
      });
    }
  }

  updateDependants() {
    this.dependants.forEach((dependant) => {
      const id = dependant.getAttribute("data-quantity-radio-group-follow");
      const radio = document.getElementById(id);
      dependant.disabled = !radio.checked;
    });
  }
}

customElements.define("quantity-radio-group", QuantityRadioGroup);
